import { createContext, useContext, useEffect, useState } from "react";
import type { UserSettingsContextType } from "./UserSettingsContextType";
import { Auth } from "@digatex/digatex-ui-lib";
const UserSettingsContext = createContext<UserSettingsContextType | undefined>(undefined);

export const useUserSettingsContext = () => {
    const context = useContext(UserSettingsContext);

    if (!context) throw new Error("useUserSettingsContext must be used inside UserSettingsProvider");
    return context;
};

export const UserSettingsProvider = ({ children }: { children: React.ReactNode }) => {
    const [currentUserRoles, setCurrentUserRoles] = useState<string[]>([]);

    useEffect(() => {
        const currentUserToken = Auth.tokenParsed();
        const roles = currentUserToken.realm_access?.roles;
        setCurrentUserRoles(roles)
    }, [])

    return (
        <UserSettingsContext.Provider
            value={{ currentUserRoles, setCurrentUserRoles }}>
            {children}
        </UserSettingsContext.Provider>
    );
};
